import { useMemo } from 'react';
import PropTypes from 'prop-types';
import { ENTRY_TYPES } from '../constants';

const { bool, oneOf } = PropTypes;

export const useEntryType = ({ entryType, skipEntryTypeCheck }) => {
  const isValidEntryType = useMemo(() => {
    return ENTRY_TYPES.includes(entryType);
  }, [entryType]);
  return skipEntryTypeCheck ? true : isValidEntryType;
};

useEntryType.propTypes = {
  entryType: oneOf(ENTRY_TYPES),
  skipEntryTypeCheck: bool
};

useEntryType.defaultProps = {
  entryType: '',
  skipEntryTypeCheck: false
};
